import React, { FunctionComponent, useCallback, useMemo, useRef } from "react"
import { useHistory, useRouteMatch } from "react-router"
import { Link } from "react-router-dom"
import DotButton from "../../components/Buttons/DotButton"

import { iDoc } from "../../definitions/iDoc"
import { eImageVersions } from "../../definitions/Image"
import { iBasicQuery } from "../../definitions/interfaces"
import { iRoles } from "../../definitions/Roles"
import { useData } from "../../hooks/useData"
import { useImage } from "../../hooks/useImage"
import { useImageUrl } from "../../hooks/useImageUrl"

interface iProps {
  cover?: string
  handleSubmit?: () => void
  handleDelete?: () => void
  submitDeleteText: string
  submitText: string
  isLoading?: boolean
  type?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  access?: any
}

const RolesHeader: FunctionComponent<iProps> = ({
  handleSubmit,
  handleDelete,
  isLoading = false,
  submitDeleteText,
  submitText,
  access,
  cover,
}) => {
  console.log(access)

  const history = useHistory()

  const match = useRouteMatch<iDoc>()
  const _url = useRef(match.params._id)

  const { data, setQuery } = useData<iDoc & iBasicQuery, iRoles>({
    link: "/v1/roles",
    defaultQuery: { _id: _url.current },
    shouldPingForData: false,
    shouldListenForHistory: false,
  })

  const item = useMemo(() => (data && data[0]) || {}, [data])

  useMemo(() => {
    if (match.params._id !== _url.current) {
      setQuery({ _id: match.params._id })
      _url.current = match.params._id
    }
  }, [match.params._id])

  const handleHisoryBack = useCallback((e: React.SyntheticEvent) => {
    e.preventDefault()
    history.goBack()
  }, [])

  const { file } = useImage({
    fileId: cover,
    fileCollection: "Files_ArtPiecesPreview",
  })

  const coverImage =
    file && useImageUrl(eImageVersions.XLWRegular, file.versions)

  return (
    <div className="inspector-header">
      <div className="inspector-cover-wrap">
        <div
          className="inspector-cover"
          style={{ backgroundImage: `url(${coverImage})` }}
        ></div>
        <div className="inspector-cover-overlay">
          <div className="inspector-headline">
            <Link to={"#"} onClick={handleHisoryBack}>
              <i className="fa fa-chevron-left"></i>
              <span>Back</span>
            </Link>

            <div className="d-flex">
              {access && access.canDelete && (
                <DotButton
                  isLoading={isLoading}
                  className={`btn-red submit-button`}
                  text={submitDeleteText}
                  onClick={handleDelete}
                  type="button"
                >
                  {submitDeleteText}
                </DotButton>
              )}
              {access && access.canEdit && (
                <DotButton
                  className={`btn-blue submit-button`}
                  text={submitText}
                  isLoading={isLoading}
                  onClick={handleSubmit}
                  type="button"
                >
                  {submitText}
                </DotButton>
              )}
            </div>
          </div>
          <h1 className="inspector-title">Inspector {item.name}</h1>
        </div>
      </div>
    </div>
  )
}

export default RolesHeader
